const en = {
  // Navigation
  nav: {
    dashboard: 'Dashboard',
    myDashboard: 'My Dashboard',
    shipments: 'Shipments',
    tracking: 'Tracking',
    payments: 'Payments',
    myPayments: 'My Balance',
    arnulfo: 'Arnulfo',
    pricing: 'Pricing',
    certificates: 'Certificates',
    alerts: 'Alerts',
    email: 'Email',
    reports: 'Reports',
    sla: 'Performance',
    operationsAnalytics: 'Operations by party',
    superAdmin: 'Super Admin',
    audit: 'Audit',
    clients: 'Clients',
    importers: 'Importers',
    suppliers: 'Suppliers',
    catalogs: 'Catalogs',
    users: 'Users',
    adminMaster: 'Master Admin',
    clientView: 'Client View',
    aiArancel: 'AI Tariff',
    logout: 'Logout',
  },
  // Common
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    noData: 'No data',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    name: 'Name',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    confirm: 'Confirm',
    apply: 'Apply',
    all: 'All',
    none: 'None',
    unknown: 'Unknown',
    notAvailable: 'Not available',
    success: 'Success',
    error: 'Error',
    viewMore: 'View more',
    viewLess: 'View less',
    created: 'Created',
    updated: 'Updated',
    noResults: 'No results',
    total: 'Total',
    of: 'of',
    enabled: 'Enabled',
    disabled: 'Disabled',
    configure: 'Configure',
    details: 'Details',
    download: 'Download',
    upload: 'Upload',
    select: 'Select',
    required: 'Required',
    optional: 'Optional',
    new: 'New',
    create: 'Create',
    unassigned: 'Unassigned',
    select: 'Select',
    description: 'Description',
    notes: 'Notes',
    type: 'Type',
    from: 'From',
    to: 'To',
    period: 'Period',
    errorSaving: 'Error saving',
    errorDeleting: 'Error deleting',
    errorLoading: 'Error loading data',
    errorUpdating: 'Error updating',
    errorCreating: 'Error creating',
    savedOk: 'Saved successfully',
    deletedOk: 'Deleted successfully',
    updatedOk: 'Updated successfully',
    createdOk: 'Created successfully',
    passwordsNoMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordUpdated: 'Password updated successfully',
    emailResetSent: 'If the email exists, you will receive a reset link',
    pdfOnly: 'PDF files only',
    fieldRequired: 'Field required',
    nameRequired: 'Name is required',
    codeAndLabelRequired: 'Code and label are required',
    contactFormSuccess: 'Thank you! We will get in touch soon.',
    contactFormError: 'Error sending. Please try again.',
    contactFormRequired: 'Please fill in the required fields',
    processingExcel: 'Processing Excel file...',
    errorToggleStatus: 'Error changing status',
    statusChanged: 'Status updated',
    noPermission: 'You do not have permission to access',
    selectAtLeastOneField: 'Select at least one field to update',
    creating: 'Creating...',
    saving: 'Saving...',
    update: 'Update',
    yes: 'Yes',
    no: 'No',
    select: 'Select...',
  },
  // Auth / Login
  auth: {
    login: 'Login',
    loginTitle: 'Login',
    loginSubtitle: 'Enter your credentials to access the system',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    noAccount: "Don't have an account? Request access",
    welcome: 'Welcome',
    rememberMe: 'Remember me',
    loginButton: 'Login',
    showDemo: 'Visit in demo mode',
  },
  // Landing
  landing: {
    heroTitle: 'Import operations management system',
    heroSubtitle: 'Full control of your shipments and containers',
    getStarted: 'Get Started',
    login: 'Login',
  },
  // Dashboard
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Real-time container overview',
    totalContainers: 'Total Containers',
    activeContainers: 'Active Containers',
    delivered: 'Delivered',
    inTransit: 'In Transit',
    inPort: 'In Process',
    pending: 'Pending',
    avgDaysInPort: 'Avg. Days in Port',
    containerEvolution: 'Container Evolution',
    containerStatus: 'Containers by Status',
    currentDistribution: 'Current distribution',
    arrivalsVsDeliveries: 'Arrivals vs Deliveries',
    recentActivity: 'Recent Activity',
    certificates: 'Certificates',
    expiring: 'expiring soon',
    expired: 'expired',
    allValid: 'All certificates are valid',
    viewAllCertificates: 'View all certificates',
    daysRemaining: 'remaining',
    daysExpired: 'Expired',
    staleSync: 'Stale sync',
    staleSyncDesc: 'Released w/o update in >24h',
    staleSyncOne: 'case',
    staleSyncMany: 'cases',
    staleSyncEmpty: 'All released containers are syncing fine',
    staleSyncViewHealth: 'View sync health',
    customize: 'Customize',
    newShipment: 'New Shipment',
    navigating: 'Navigating',
    waitingDelivery: 'Waiting delivery',
    arrivalToDelivery: 'Arrival to delivery',
    monthlyHistoric: 'Showing monthly history',
    useDateFilter: 'Use the date filter to view a specific period',
    portAlerts: 'Port Alerts',
    pendingCosts: 'Pending Costs',
    deliveredContainers: 'Delivered Containers',
    monthlySummary: 'Monthly Summary',
    clientsChart: 'Distribution by Client',
    importerChart: 'Distribution by Importer',
    widgetSettings: 'Widget Settings',
    widgetSettingsDesc: 'Select which widgets to show on your dashboard',
    arrivals: 'Arrivals',
    deliveriesLabel: 'Deliveries',
    topClients: 'Top Clients',
    topClientsByContainers: 'Top Clients by Containers',
    containersByImporter: 'Containers by Importer',
    noClient: 'No client',
    noImporter: 'No importer',
    containersUnit: 'containers',
    periodComparison: 'Period Comparison',
    previousMonth: 'Previous month',
    currentMonth: 'Current month',
    comparing: 'Comparing...',
    compare: 'Compare',
    metric: 'Metric',
    current: 'Current',
    previous: 'Previous',
    change: 'Change',
    containersArrived: 'Containers Arrived',
    containersDelivered: 'Containers Delivered',
    newShipments: 'New Shipments',
    etaPredictionEngine: 'ETA Prediction Engine',
    basedOnHistorical: 'Based on historical data',
    calculating: 'Calculating...',
    calculateEtas: 'Calculate ETAs',
    overallAverage: 'Overall Average',
    days: 'days',
    range: 'Range',
    samples: 'samples',
    clickForDetail: 'Click for detailed analysis',
    byClientTop5: 'By client (top 5)',
    noName: 'No name',
    byPort: 'By port',
    noPort: 'No port',
    avgDaysDescription: 'Average days from port arrival to delivery',
    deliveryTimes: 'Delivery Times',
    detailedAnalysis: 'Detailed Delivery Time Analysis',
    detailedAnalysisDesc: 'Analyze delivery times by different factors and periods',
    periodFilterLabel: 'Period:',
    clear: 'Clear',
    periodAverage: 'Period average',
    deliveriesAnalyzed: 'deliveries analyzed',
    tabSummary: 'Summary',
    tabByClient: 'By Client',
    tabByPort: 'By Port',
    tabByCarrier: 'By Carrier',
    tabByDestination: 'By Destination',
    tabTrend: 'Trend',
    noDataAvailable: 'No data available',
    noDataInRange: 'No data in selected range',
    useDateFilterFull: 'Use the date filter to view a specific period',
    year: 'Year',
    preferencesSaved: 'Preferences saved',
    preferencesError: 'Error saving preferences',
    etaError: 'Error calculating ETAs',
    etaSuccess: 'ETAs calculated successfully',
    recentShipments: 'Recent Shipments',
    viewAll: 'View all',
    mblBl: 'MBL/BL',
    client: 'Client',
    statusCol: 'Status',
    containersCol: 'Containers',
    lastUpdate: 'Last Update',
    noShipmentsRegistered: 'No shipments registered',
    daysInPortLabel: 'days in port',
    noActiveAlerts: 'No active alerts',
    allCostsCalculated: 'All costs calculated',
    deliveredTitle: 'Delivered',
    containersCompleted: 'Completed containers',
    noDeliveriesInPeriod: 'No deliveries in this period',
    viewMore: 'View',
    more: 'more',
    viewLess: 'View less',
    expiringCertificates: 'Expiring Certificates',
    expiredCount: 'expired',
    deliveriesCount: 'deliveries',
    notCalculated: 'Not calculated',
    backToAutoData: 'Back to automatic data',
    expiredDaysAgo: 'Expired',
    daysRemaining: 'remaining',
  },
  // Shipments
  shipments: {
    title: 'Shipments',
    subtitle: 'Shipment and container management',
    newShipment: 'New Shipment',
    mbl: 'MBL',
    client: 'Client',
    importer: 'Importer',
    supplier: 'Supplier',
    origin: 'Origin',
    destination: 'Destination',
    port: 'Port',
    etaReal: 'Actual ETA',
    entregaReal: 'Actual Delivery',
    containers: 'Containers',
    timeline: 'Timeline',
    costs: 'Costs',
    internalNotes: 'Internal Notes',
    pedimentos: 'Customs Forms',
    documents: 'Documents',
    history: 'History',
    information: 'Information',
    addContainers: 'Add Containers',
    containerNumber: 'Container',
    carrier: 'Carrier',
    trafficLight: 'Traffic Light',
    arrival: 'Arrival',
    delivery: 'Delivery',
    refCarga: 'Cargo Ref.',
    pedimento: 'Customs Form',
    daysInPort: 'Days in Port',
    quickEdit: 'Quick Edit',
    transport: 'Transport',
    train: 'Train',
    truck: 'Truck',
    pending: 'Pending',
    reference: 'Reference',
    number: 'Number',
    route: 'Route',
    inProgress: 'In Progress',
    completed: 'Completed',
    dates: 'Dates',
    containerNumbers: 'Container Numbers',
    paid: 'Paid',
    bulkSelect: 'container(s) selected',
    deselect: 'Deselect',
    noContainers: 'No containers registered',
    sortAZ: 'A-Z',
    sortZA: 'Z-A',
    sortNewest: 'Newest',
    sortOldest: 'Oldest',
    noShipments: 'No shipments',
    searchPlaceholder: 'Search by MBL, client, importer...',
    generalStatus: 'General Status',
    totalShipments: 'shipments',
    containersPending: 'pending containers',
    editShipment: 'Edit Shipment',
    deleteShipment: 'Delete Shipment',
    shipmentDetails: 'Shipment Details',
    free: 'Free',
    inspection: 'Inspection',
    na: 'N/A',
    enterContainerNumbers: 'Enter container numbers, one per line',
    updated: 'containers updated',
    onlyFilledFields: 'Only fields with values will be updated',
    noChange: 'No change',
    applyTo: 'Apply to',
    arrivalDate: 'Arrival Date',
    deliveryDate: 'Delivery Date',
    viewLess: 'View less',
    viewMore: 'View more',
    exportingExcel: 'Generating Excel file...',
    exportedOk: 'File exported successfully',
    exportError: 'Error exporting',
    deleteError: 'Error deleting shipment',
    mblChangeError: 'Error changing MBL',
    bulkUpdateError: 'Error in bulk update',
    generatingTemplate: 'Generating Excel template...',
    templateDownloaded: 'Template downloaded. Edit the file and upload it to apply changes.',
    bulkImportInstructions1: 'Download the Excel template with the "Excel" button',
    bulkImportInstructions2: 'Edit the green cells (gray ones are read-only)',
    bulkImportInstructions3: 'Save the file and upload it here',
    errorLoadingShipment: 'Error loading shipment',
    errorSaving: 'Error saving',
    errorAddingContainers: 'Error adding containers',
    errorUpdatingContainer: 'Error updating',
    errorDeletingContainer: 'Error deleting',
    errorCreatingEvent: 'Error creating event',
    errorCreatingNote: 'Error creating note',
    errorUploadingImage: 'Error uploading image',
    savedChanges: 'Changes saved',
    containersAdded: 'Containers added',
    containerDeleted: 'Container deleted',
    eventCreated: 'Event created',
    eventDeleted: 'Event deleted',
    noteCreated: 'Note created',
    noteDeleted: 'Note deleted',
    imageUploaded: 'Image uploaded',
    errorCreatingPort: 'Error creating port',
    portCreated: 'Port created',
    clientCreated: 'Client created',
    errorCreatingClient: 'Error creating client',
    importerCreated: 'Importer created',
    errorCreatingImporter: 'Error creating importer',
    supplierCreated: 'Supplier created',
    errorCreatingSupplier: 'Error creating supplier',
    mblRequired: 'MBL/BL is required',
    clientRequired: 'Client is required',
    shipmentCreated: 'Shipment created successfully',
    errorCreatingShipment: 'Error creating shipment',
    // Filters / actions header
    excel: 'Excel',
    uploadExcel: 'Upload Excel',
    prePedimento: 'Proforma',
    prePedimentoBulk: 'Proforma (batch)',
    repairSync: 'Repair Sync',
    calcEtas: 'Calculate ETAs',
    notDelivered: 'Not Delivered',
    deliveryStatus: 'Delivery Status',
    inOperation: 'In operation (not delivered)',
    deliveredOnly: 'Delivered only',
    dates: 'Dates',
    advanced: 'Advanced',
    allClients: 'All clients',
    allImporters: 'All importers',
    allStatus: 'All statuses',
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
    // Advanced filters
    advancedFilters: 'Advanced Filters',
    carrier: 'Carrier',
    terminal: 'Terminal',
    customsAgent: 'Customs Broker',
    customsTrafficLight: 'Customs Light',
    withPedimento: 'With pedimento',
    withoutPedimento: 'Without pedimento',
    delayInPort: 'Delay in port (days ≥)',
    clearAdvanced: 'Clear advanced',
    clearDates: 'Clear dates',
    arrivalAtPort: 'Arrival at Port',
    arrivalAtPortHint: 'Uses Real ETA, falls back to Initial ETA',
    deliveryHint: 'Actual delivery date to client',
    partialMatch: 'Partial name...',
    redLight: '🔴 Red',
    greenLight: '🟢 Green',
    noLight: 'No data',
    contNumberPlaceholder: '# Container',
    cargoTypePlaceholder: 'Cargo Type',
    referencePlaceholder: 'Reference',
    pedimentoPlaceholder: 'Pedimento',
    // Action buttons
    newShipment: 'New Shipment',
    actions: 'Actions',
    // Table headers
    client: 'Client',
    importer: 'Importer',
    cargoType: 'Cargo Type',
    status: 'Status',
    docs: 'Docs',
    docsHint: 'Documents sent to customs broker',
    containers: 'Cont.',
    days: 'Days',
    daysHint: 'Days from arrival to delivery',
    initialEta: 'Initial ETA',
    initialEtaHint: 'Initial Port ETA',
    realEta: 'Real ETA',
    realEtaHint: 'Real Port ETA',
    estDelivery: 'Est. Delivery',
    estDeliveryHint: 'Estimated Delivery',
    realDelivery: 'Real Delivery',
    cost: 'Cost',
    lastUpdate: 'Last Upd.',
    countSuffix: 'shipments',
    bulkEdit: 'Bulk Edit',
    bulkEditDescription: 'Update {count} selected shipments. Only fields you fill in will be modified.',
    noChange: 'No change',
    cancel: 'Cancel',
    update: 'Update',
    importFromExcel: 'Import from Excel',
    importExcelDescription: 'Upload a previously exported Excel file with the changes to apply.',
    instructions: 'Instructions:',
    clickToSelectFile: 'Click to select file',
    onlyXlsx: 'Only .xlsx files',
    processingFile: 'Processing file...',
    // Loading / empty state
    loadingShipments: 'Loading shipments...',
    noShipmentsFound: 'No shipments found',
    noActiveForClient: 'You have no active shipments',
    searchMbl: 'Search MBL...',
    // Bulk actions
    bulkEditCount: 'Edit',
    bulkRevalidate: 'Revalidate',
    bulkRevalidateTitle: 'Revalidate all selected shipments against carriers (emergency only — automatic revalidation runs daily at 5am Mexico time)',
    revalidateShipmentTitle: 'Revalidate shipment against carrier (emergency only — automatic revalidation runs daily)',
    revalidateShipmentConfirm: 'Revalidate all containers of {mbl} against the carrier? Fake port/ferrovalle data will be deleted if the carrier indicates containers have not yet arrived.',
    revalidating: 'Revalidating shipment {mbl}...',
    bulkRevalidateConfirm: 'Revalidate {count} selected shipment(s) against carriers? Fake port/ferrovalle data will be deleted if the carrier indicates containers have not yet arrived. This may take several minutes.',
    bulkRevalidating: 'Revalidating {count} shipments...',
    bulkRevalidateResult: 'Bulk revalidation: {ok} OK · {fail} failed · Port purged={port} · Ferrovalle={fer}',
    // Proforma
    prePedimentoOnlyPdf: 'PDF only',
    prePedimentoAnalyzing: 'Analyzing proforma...',
    prePedimentoError: 'Error processing proforma',
    prePedimentoTitle: 'Upload proforma PDF — auto-detects MBL, container and assigns customs form number',
    prePedimentoBulkTitle: 'Upload several proforma PDFs at once — extracts each number and assigns it automatically (the PDF is not stored)',
    // Repair
    repairConfirm: 'Run full repair now?\n\nThis runs:\n1. Ferrovalle scrape (looks for pending containers)\n2. Port scrape\n3. Status sync (promotes status based on new data)\n\nTakes ~2-5 minutes. Safe — never downgrades status, only promotes.',
    repairTriggered: 'Repair triggered in background...',
    repairRunning: 'Repair running. Come back in 2-5 min and refresh to see changes.',
    repairError: 'Error triggering repair',
    repairTitle: 'Repair sync: runs Ferrovalle + Port + Status sync now',
    // ETAs
    etasOk: 'ETAs calculated for {count} shipments',
    etasNone: 'No pending shipments to calculate ETA',
    etasError: 'Error calculating ETAs',
    etasTitle: 'Calculates Estimated Delivery ETA for pending shipments based on historical data',
    // Delete dialog
    deleteShipmentTitle: 'Delete Shipment',
    deleteShipmentConfirm: 'Are you sure you want to delete shipment',
    deleteShipmentOf: 'of',
    deleteShipmentWarn: 'This action will also delete all containers, events, notes and associated costs.',
    deleteIrreversible: 'This action cannot be undone.',
    deleteTitle: 'Delete shipment',
    deleting: 'Deleting...',
    deletedOk: 'Shipment {mbl} deleted',
    // Edit MBL dialog
    editMblTitle: 'Edit MBL',
    editMblDesc: 'Change the MBL number. All related data (containers, events, notes) will be updated automatically.',
    currentMbl: 'Current MBL',
    newMblLabel: 'New MBL',
    newMblPlaceholder: 'New MBL number',
    editMblBtn: 'Edit MBL',
    // Container subtable
    containerLoading: 'Loading containers...',
    noContainersRegistered: 'No containers registered',
    containerNum: 'Container',
    arrivalCol: 'Arrival',
    deliveryCol: 'Delivery',
    daysInPortCol: 'Days in Port',
    // Mobile card
    expand: 'View more',
    collapse: 'View less',
    inactiveTag: '(inactive)',
    noContainersFlag: 'No containers',
    docsPending: 'Docs pending',
    sentOn: 'Sent',
    autoCalculated: 'Auto-calculated',
    bulkEditCountLabel: '({count})',
    selected: 'selected',
    exportAll: 'Export all',
    exportSelected: 'Export {count} selected',
    excelLabel: 'Excel',
    excelLabelCount: 'Excel ({count})',
    importDocsTitle: 'Import from Notion',
    // Events tab
    newEvent: 'New Event',
    eventType: 'Event Type',
    selectPlaceholder: 'Select',
    eventDate: 'Date',
    containerOptional: 'Container (optional)',
    blLevel: 'BL Level',
    visibleToClient: 'Visible to client',
    noteOptional: 'Note (optional)',
    eventNotePlaceholder: 'Event note...',
    addEvent: 'Add',
    noEventsRegistered: 'No events recorded',
    noEventsInCategory: 'No events in this category',
    eventFilter: {
      all: 'All',
      aduana: 'Customs',
      transporte: 'Transport',
      almacen: 'Warehouse',
    },
    internalOnly: 'Internal only',
    // Notes tab
    newInternalNote: 'New Internal Note',
    noteLabel: 'Note',
    notePlaceholder: 'Write the internal note...',
    addNote: 'Add Note',
    noClientNotes: 'No customs notes available',
    noInternalNotes: 'No internal notes',
    noteSourceManual: 'Manual',
    noteSourceOutlook: 'Outlook',
    noteSourceSystem: 'System',
    noteSourceSoia: 'SOIA / Customs',
    visibleToClientBadge: 'Visible to client',
    // Detail page header / sections
    syncingNow: 'Syncing...',
    syncNow: 'Sync now',
    syncNowTitle: 'Force update from carriers, ports and Ferrovalle',
    viewingAsClient: 'Viewing as client',
    customsSoia: 'Customs / SOIA',
    // Info tab sections
    generalData: 'General Data',
    datesAndEtas: 'Dates and ETAs',
    importerSupplier: 'Importer / Supplier',
    operationCost: 'Operation Cost',
    internalFields: 'Internal Fields',
    shipmentDocs: 'Shipment Documents',
    changeHistory: 'Change History',
    pedimentosHeader: 'Customs Forms',
    // Field labels (detail)
    originLabel: 'Origin',
    destinationFinalLabel: 'Final Destination',
    arrivalPort: 'Arrival Port',
    selectPort: 'Select port',
    addPortBtn: 'Add Port',
    portName: 'Port Name',
    addPortTitle: 'Add new port',
    incoterm: 'Incoterm',
    vessel: 'Vessel',
    cargoTypeLabel: 'Cargo Type',
    cargoTypePh: 'e.g. FCL, LCL, Raw material, etc.',
    destinationPh: 'e.g. CDMX, Monterrey',
    portNamePh: 'e.g. Manzanillo',
    generalStatusLabel: 'General Status',
    activeLabel: 'Active',
    etdOrigin: 'ETD Origin',
    originDepartureDate: 'Departure date from origin',
    docsSentToAgent: 'Docs Sent to Broker',
    docsSendDate: 'Document send date',
    initialPortEta: 'Initial Port ETA',
    initialArrivalDate: 'Initial estimated arrival date',
    realPortEta: 'Real Port ETA',
    realArrivalDate: 'Actual port arrival date',
    estimatedDeliveryEta: 'Estimated Delivery ETA',
    estimatedDeliveryDate: 'Estimated delivery date to client',
    realDeliveryLabel: 'Actual Delivery',
    realDeliveryDate: 'Actual delivery date',
    createdAtLabel: 'Created',
    lastUpdateLabel: 'Last update',
    notAssigned: 'Unassigned',
    totalCostUsd: 'Total Cost (USD)',
    costCalculated: 'Cost Calculated',
    breakdownImage: 'Breakdown Image',
    uploadBtn: 'Upload',
    currentBreakdown: 'Current Breakdown',
    costBreakdown: 'Cost Breakdown',
    finalQuoteDone: 'Final Quote Completed',
    arnulfoApplies: 'Arnulfo Applies',
    arnulfoStatus: 'Arnulfo Status',
    arnulfoPending: 'Pending',
    journeyOrigin: 'Origin',
    journeyOriginShort: 'Origin',
    journeyTransit: 'In Transit',
    journeyTransitShort: 'Transit',
    journeyPort: 'At Port',
    journeyPortShort: 'Port',
    journeyLand: 'Inland Transit',
    journeyLandShort: 'Inland',
    journeyTrain: 'Train / Ferrovalle',
    journeyTrainShort: 'Train',
    journeyDelivered: 'Delivered',
    journeyDeliveredShort: 'Delivered',
    arnulfoPaid: 'Paid',
  },
  reports: {
    title: 'Monthly Report',
    subtitle: 'Operations summary by month. Sent automatically on the 1st of each month.',
    preview: 'Preview',
    sendByEmail: 'Send by Email',
    loadError: 'Error loading report',
    sentOk: 'Report sent by email',
    sendError: 'Error sending report',
    metrics: {
      totalShipments: 'Total Shipments',
      containers: 'Containers',
      delivered: 'Delivered',
      active: 'Active',
      inPort: 'At Port',
      certsExpiring: 'Certs Expiring',
    },
    period: 'Period',
    newShipments: 'New shipments',
    arrivalsThisMonth: 'Arrivals this month',
    deliveriesThisMonth: 'Deliveries this month',
    inTransitToMexico: 'In transit to Mexico',
    avgDaysInPort: 'Avg. days since arrival',
    days: 'days',
    shipmentsByStatus: 'Shipments by Status',
    importers: 'Importers',
    noImportersData: 'No importer data for this period',
    upcomingRenewals: 'Upcoming Renewals (30 days)',
    contractTag: 'Contract',
    certificateTag: 'Certificate',
    months: {
      1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June',
      7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December',
    },
    statusLabels: {
      NO_SALIDO_CHINA: 'Not Departed from China',
      EN_TRANSITO_PUERTO: 'In Maritime Transit',
      ARRIBADO_PUERTO: 'Arrived at Port',
      EN_TRANSITO_TERRESTRE: 'In Inland Transit',
      ENTREGADO: 'Delivered',
      ENTREGADO_PEND_DEMORAS: 'Delivered (Pending Demurrage)',
    },
  },
  superAdmin: {
    title: 'SaaS Dashboard',
    subtitle: 'SaaS administration panel',
    exportShipments: 'Export Shipments',
    importJson: 'Import JSON',
    exportTitle: 'Export pending shipments as JSON (migrate prod → preview)',
    importTitle: 'Import JSON bundle from another environment',
    newClient: 'New Client',
    newClientTitle: 'New Client / Organization',
    name: 'Name',
    namePh: 'Company name',
    type: 'Type',
    plan: 'Plan',
    contactEmail: 'Contact email',
    create: 'Create',
    clients: 'Clients',
    searchPh: 'Search...',
    organization: 'Organization',
    pricePerMonth: 'Price/month',
    state: 'Status',
    users: 'Users',
    shipments: 'Shipments',
    contact: 'Contact',
    actionsCol: 'Actions',
    noClients: 'No clients registered',
    customOverride: 'Custom override',
    edit: 'Edit',
    enterPortal: 'Enter portal',
    invite: 'Invite',
    delete: 'Delete',
    editOrg: 'Edit',
    subscription: 'Subscription',
    cycle: 'Cycle',
    monthly: 'Monthly',
    yearly: 'Yearly',
    typeComercializadora: 'Trading Company',
    typeAgenteAduanal: 'Customs Broker',
    typeCliente: 'Client',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    activate: 'Activate',
    deactivate: 'Deactivate',
    monthlyOverride: 'Monthly price (override)',
    monthlyOverridePh: 'Leave empty to use plan price',
    saveChanges: 'Save Changes',
    deleteConfirm: 'Are you sure you want to delete the organization {name}? This will delete all its users and data.',
    deleteConfirm2: 'Confirm by typing the organization name',
    enterPortalConfirm: 'Enter the {name} portal as administrator? Your current session will be saved.',
    confirmEnter: 'Enter',
    inviteUser: 'Invite User',
    inviteEmail: 'New user email',
    inviteName: 'Name',
    inviteRole: 'Role',
    sendInvite: 'Send Invitation',
    manageUsers: 'Manage Users',
    noUsers: 'No users',
    removeUser: 'Remove User',
    confirmRemove: 'Remove this user? This action cannot be undone.',
    backToOrgs: 'Back',
    statsActiveOrgs: 'Active Organizations',
    statsTotalUsers: 'Total Users',
    statsTotalShipments: 'Total Shipments',
    statsTotalContainers: 'Containers',
    statsMrr: 'MRR',
    statsArr: 'ARR',
    monthlyRecurring: 'Monthly recurring',
    annualRecurring: 'Annual recurring',
    overall: 'Overall',
    editOrgTitle: 'Edit',
    nameField: 'Name',
    emailContact: 'Contact Email',
    maxOperators: 'Max Operators',
    maxClients: 'Max Clients',
    nextPayment: 'Next Payment',
    monthlyPriceOverride: 'Monthly price (override)',
    overrideHelp: 'Empty = use plan price',
    featuresActive: 'Active Features',
    internalNotes: 'Internal notes',
    notesPh: 'Notes about this client...',
    inviteUserTo: 'Invite User to',
    emailLabel: 'Email',
    emailPh: 'email@user.com',
    fullNamePh: 'Full name',
    roleLabel: 'Role',
    roleOps: 'Operator',
    roleClient: 'Client',
    roleAdmin: 'Admin',
    sendInvitation: 'Send Invitation',
    usersOf: 'Users of',
    impersonateTitle: 'Login as this user',
    activeUser: 'Active',
    inactiveUser: 'Inactive',
    inviteUserBtn: 'Invite User',
    featLabel: {
      shipments: 'Shipments',
      containers: 'Containers',
      events: 'Events',
      internal_notes: 'Internal Notes',
      dashboard: 'Dashboard',
      client_portal: 'Client Portal',
      tracking_ports: 'Port Tracking',
      tracking_carriers: 'Carrier Tracking',
      document_generation: 'Document Gen.',
      cost_breakdown: 'Costs',
      certificates: 'Certificates',
      alerts: 'Alerts',
      monthly_report: 'Monthly Report',
      sla_dashboard: 'SLA Dashboard',
      multi_user: 'Multi-User',
      excel_export: 'Excel Export',
      audit_history: 'History',
      client_arnulfo: 'Arnulfo Dashboard (Client)',
      client_force_soia: 'Force SOIA (Client)',
    },
  },
  statusCodes: {
    NO_SALIDO_CHINA: 'Not Departed from China',
    BOOKING_NO_SALIDO: 'Booking - Not Departed',
    EN_TRANSITO_PUERTO: 'In Transit to Port',
    EN_TRANSITO_MARITIMO: 'In Maritime Transit',
    EN_TRANSITO: 'In Transit',
    ARRIBADO_PUERTO: 'Arrived at Port',
    EN_PUERTO: 'At Port',
    EN_PUERTO_LIBERACION: 'At Port - Release in Progress',
    EN_PUERTO_LIBERADO: 'At Port - Released',
    EN_PUERTO_SEMAFORO_ROJO: 'At Port - Red Light Inspection',
    EN_PUERTO_CARGA_FERRO: 'At Port - Loading to Train',
    EN_TRANSITO_TERRESTRE: 'In Inland Transit',
    EN_PANTACO: 'At Pantaco',
    EN_DESTINO: 'At Destination',
    ENTREGADO: 'Delivered',
    ENTREGADO_PEND_DEMORAS: 'Delivered / Pending Demurrage',
    NO_ARRIBADO: 'Not Arrived',
    DESPACHO_EN_PROCESO: 'Clearance in Progress',
    LIBERADO: 'Released',
    LLEGADA_PATIO: 'Arrived at Yard',
  },
  trafficLight: {
    GREEN: 'Clear',
    GREEN_TitleHelp: 'Clear',
    RED: 'Inspection',
    NA: 'N/A',
    NA_TitleHelp: 'Not Applicable',
  },
  costStatus: {
    pending: 'Pending',
    calculated: 'Calculated',
  },
  onboarding: {
    skip: 'Skip tour',
    next: 'Next',
    back: 'Back',
    finish: 'Get started',
    stepOf: 'Step {current} of {total}',
    dontShowAgain: "Don't show again",
    // Common
    welcomeTitle: 'Welcome to OFIMEX',
    welcomeBody: 'Your platform to manage imports to Mexico end-to-end: real-time tracking from carrier to port and Ferrovalle, customs forms automation, SLA alerts and monthly reports.',
    // Operator
    opsTrackingTitle: 'Connected tracking',
    opsTrackingBody: 'OFIMEX connects with carriers (MSC, Evergreen, COSCO, Hapag, Maersk, ONE, OOCL, ZIM, etc.), ports (Contecon, TIMSA, SSA Manzanillo) and Ferrovalle.',
    opsAlertsTitle: 'Alerts and reports',
    opsAlertsBody: 'Configure alerts by container days since arrival, pending ETA or unsent documents at /alerts. Monthly report is auto-generated and emailed on the 1st of each month.',
    // Client
    clientTrackingTitle: 'Track your shipments in real time',
    clientTrackingBody: 'At /shipments you will see the general status, container, estimated arrival and delivery date of each of your shipments. Click the MBL to see the full timeline.',
    clientDocsTitle: 'Documents and customs forms',
    clientDocsBody: 'When your customs broker processes the customs form, it will appear automatically in the shipment detail alongside your associated documents (BL, invoice, certificates).',
    clientNotifTitle: 'Email notifications',
    clientNotifBody: 'When your container arrives at the port, is released or departs to Ferrovalle, you will receive an email. Configure your alerts at /alerts.',
    // Operator (full ops flow)
    opsCreateTitle: 'Create and edit shipments',
    opsCreateBody: 'In /shipments you can create a new BL ("+ New Shipment" button) assigning client, importer, MBL and vessel. To edit, open the BL detail — the ✎ button next to the MBL lets you change the number anytime.',
    opsDocsTitle: 'Documents, pedimentos and costs',
    opsDocsBody: 'In the "Documents" tab you upload BL, invoice and certificates. The "Pedimentos" tab automatically reads XML data. In "Costs" you record port, carrier and customs payments.',
    opsDeliveryTitle: 'Mark delivered & notify',
    opsDeliveryBody: 'OFIMEX automatically detects when the container returns empty to Ferrovalle ("FI Vacíos") and marks it as delivered, sending the email to the client. If you need to mark manually, do it from the Information tab.',
    // Admin
    adminUsersTitle: 'Users and permissions',
    adminUsersBody: 'In /users you manage your team: add operators, assign granular permissions per module (shipments, payments, costs, certificates) and restrict client access to their own data.',
    adminAuditTitle: 'Audit Logs and traceability',
    adminAuditBody: 'In /super-admin/audit-logs you see every system action (create, edit, sync, login). Useful for audits or to investigate who changed what.',
    adminTrackingHealthTitle: 'Tracking Health',
    adminTrackingHealthBody: 'In the Super Admin panel you will see "Tracking Health" — live status of the 4 scrapers (Carrier, Port, Ferrovalle, SOIA). If Ferrovalle login fails it warns you with a red banner and you can retry instantly.',
    adminReportsTitle: 'Monthly reports and SLA',
    adminReportsBody: 'In /reports you download the monthly report (PDF + CSV). In /sla you measure operational KPIs: average port-to-client time, on-time delivery %, delays. Sent automatically each day 1.',
    // Super Admin (OFIMEX staff)
    superMultiTenantTitle: 'Multi-organization view',
    superMultiTenantBody: 'As Super Admin, in /super-admin you see all organizations (orgs) using OFIMEX, their metrics and contracted plans. Each org has its own users, shipments and isolated permissions.',
    superViewAsTitle: '"View As" mode (inspection)',
    superViewAsBody: 'You can enter an org in read-only mode to diagnose without touching their data. Activate "Edit" if you need to make a manual change. Everything is recorded in Audit Logs with your identity.',
    superDiagnosticsTitle: 'Platform diagnostics',
    superDiagnosticsBody: '"Send test email" button to validate Resend, "Tracking Health" panel for the 4 scrapers, and cross-org Audit Logs. All from /super-admin.',
  },
  manual: {
    title: 'Manuals',
    description: 'Download the PDF manuals to share them with your team and your clients.',
    opsLabel: 'Operator Manual',
    opsDescription: 'For your internal team: how to manage shipments, upload proformas, set up alerts and reports.',
    clientLabel: 'Client Manual',
    clientDescription: 'To forward to your clients / importers: how to track shipments and download customs forms.',
    download: 'Download PDF',
    downloading: 'Downloading...',
    downloadError: 'Could not download the manual',
    sidebarLink: 'Manuals',
    tourLabel: 'Welcome tour',
    tourDescription: 'Replay the quick 4-step tour of how OFIMEX works.',
    tourButton: 'View tour',
  },
  // Tracking
  tracking: {
    title: 'Container Tracking',
    subtitle: 'Direct tracking with shipping lines',
    track: 'Track',
    searchPlaceholder: 'Search container, MBL or client...',
    noActiveContainers: 'No active containers',
    allCarriers: 'All',
    updateStatus: 'Update Status',
    updateAll: 'Update All',
    usingCachedData: 'Using cached data (recent)',
    dataUpdated: 'Tracking data updated',
    scrapeError: 'Could not fetch data automatically',
    scrapeAllStarted: 'Bulk update started in background',
    lastScraped: 'Last checked',
    scrapedStatus: 'Fetched status',
    location: 'Location',
    vessel: 'Vessel',
    eta: 'ETA',
    origin: 'Origin',
    destination: 'Destination',
    events: 'Tracking events',
    noAutoData: 'Could not fetch automatic data. Use the direct link:',
    visitPortal: 'Visit carrier portal',
    unknown: 'Unknown',
    portResultsFound: 'result(s) found',
    portNoResults: 'No results for this container',
    portError: 'Error querying port terminal',
    portNoContainers: 'No valid containers to query',
    portLoading: 'Error loading containers',
    portNoneFound: 'No containers found at terminal',
    timelineTitle: 'Tracking Timeline',
  },
  // Certificates
  certificates: {
    title: 'Certificates',
    subtitle: 'Product certificate management',
    product: 'Product',
    fraction: 'Fraction',
    model: 'Model',
    expirationDate: 'Expiration Date',
    daysRemaining: 'days remaining',
    daysExpired: 'Expired',
    importerName: 'Importer',
    addCertificate: 'New Certificate',
    editCertificate: 'Edit Certificate',
    noCertificates: 'No certificates',
    valid: 'Valid',
    expiringSoon: 'Expiring soon',
    expired: 'Expired',
    searchPlaceholder: 'Search product, fraction, model...',
    noCertificatesFound: 'No certificates found',
    product: 'Product',
    fraction: 'Tariff Fraction',
    model: 'Model',
    certificateNumber: 'Certificate No.',
    expirationDate: 'Expiration Date',
    issuingAuthority: 'Issuing Authority',
    allStatuses: 'All statuses',
    errorLoading: 'Error loading certificates',
    errorSaving: 'Error saving certificate',
    errorDeleting: 'Error deleting certificate',
    savedOk: 'Certificate saved',
    deletedOk: 'Certificate deleted',
    productCertificate: 'Certificate',
    contract: 'Contract',
    certificate: 'Certificate',
    contractName: 'Contract Name',
    fileUploaded: 'File uploaded successfully',
    fileUploadError: 'Error uploading file',
  },
  // Email Settings
  emailSettings: {
    title: 'Incoming Email',
    subtitle: 'Connect your email to receive automatic shipping updates',
    imapConfig: 'IMAP Configuration',
    imapHost: 'IMAP Server',
    port: 'Port',
    emailAddress: 'Email address',
    passwordLabel: 'Password',
    passwordSet: 'already set',
    leaveEmpty: 'Leave empty to keep current',
    appPasswordHint: 'For Gmail, use an "App Password" generated in your Google account',
    folder: 'Folder',
    interval: 'Interval (minutes)',
    useSSL: 'Use SSL',
    testConnection: 'Test Connection',
    checkNow: 'Check Now',
    parsedEmails: 'Received Emails',
    applyData: 'Apply Data',
    dismiss: 'Dismiss',
    pendingEmails: 'Pending',
    applied: 'Applied',
    dismissed: 'Dismissed',
    notRelevant: 'Not relevant',
    lastCheck: 'Last check',
    extractedData: 'Extracted Data',
    detectedStatus: 'Detected status',
    noEmails: 'No emails',
    noSubject: '(no subject)',
    containersFound: 'Containers',
    mblsFound: 'MBLs',
    hostRequired: 'IMAP host and email are required',
    passwordRequired: 'Enter the password',
    configSaved: 'Configuration saved',
    errorSaving: 'Error saving',
    errorTestingConn: 'Error testing connection',
    errorLoadingEmails: 'Error loading emails',
    errorCheckingInbox: 'Error checking inbox',
    errorApplying: 'Error applying',
    emailDismissed: 'Email dismissed',
    errorDismissing: 'Error dismissing',
    errorLoadingConfig: 'Error loading configuration',
  },
  // Audit
  audit: {
    title: 'Audit History',
    subtitle: 'System change log',
    entity: 'Entity',
    action: 'Action',
    user: 'User',
    changes: 'Changes',
    oldValue: 'Previous',
    newValue: 'New',
    noAuditLogs: 'No audit logs',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
  },
  // Alerts
  alerts: {
    title: 'Alert Configuration',
    subtitle: 'Set thresholds and recipients for automatic alerts',
    daysInPort: 'Days in Port',
    daysSinceArrival: 'Days since Arrival',
    expiringCertificates: 'Expiring Certificates',
    recipients: 'Recipients',
    threshold: 'Threshold (days)',
    enabled: 'Enabled',
    disabled: 'Disabled',
    runNow: 'Run Now',
    addRecipient: 'Add recipient',
    emailPlaceholder: 'email@example.com',
    configSaved: 'Configuration saved',
    errorSaving: 'Error saving configuration',
    errorLoading: 'Error loading alerts',
    alertsSent: 'Alerts sent',
    testSent: 'Test alert sent',
    errorSending: 'Error sending alerts',
    errorTesting: 'Error sending test alert',
    checkNow: 'Check Now',
    activated: 'Alert activated',
    deactivated: 'Alert deactivated',
    errorUpdating: 'Error updating',
    invalidEmail: 'Enter a valid email',
    recipientAdded: 'Recipient added',
    recipientRemoved: 'Recipient removed',
    errorAddingRecipient: 'Error adding recipient',
    errorRemovingRecipient: 'Error removing recipient',
    sendTestEmail: 'Send Test Email',
    add: 'Add',
    nameOptional: 'Name (optional)',
    noRecipientsConfigured: 'No recipients configured',
    alertHistory: 'Alert History',
    noAlertsSent: 'No alerts sent yet',
    daysInPortLog: 'days in port',
    daysSinceArrivalLog: 'days since arrival',
    sentTo: 'Sent to',
    days: 'days',
    checkCompleted: 'Check completed',
  },
  // Pricing
  pricing: {
    title: 'Historical Pricing',
    subtitle: 'Price history by product and client',
    product: 'Product',
    clientName: 'Client',
    price: 'Price',
    currency: 'Currency',
    priceDate: 'Date',
    addEntry: 'New Entry',
    noPrices: 'No price records',
    priceHistory: 'Price History',
    errorLoading: 'Error loading prices',
    errorSaving: 'Error saving price',
    errorDeleting: 'Error deleting price',
    savedOk: 'Price saved',
    deletedOk: 'Price deleted',
    editPrice: 'Edit Price',
    newPriceEntry: 'New Price Entry',
    totalRecords: 'Total Records',
    products: 'Products',
    searchPlaceholder: 'Search product, item, supplier...',
    allClients: 'All clients',
    itemNumber: 'Item #',
    supplier: 'Supplier',
    unitPrice: 'Unit Price',
    quantity: 'Quantity',
    effectiveDate: 'Effective Date',
    originCountry: 'Country of Origin',
    productRequired: 'Product and price are required',
    masterAdminOnly: 'Only Master Admin can view prices',
    confirmDelete: 'Are you sure you want to delete this record?',
    recordsImported: 'records imported',
    rowsWithErrors: 'rows with errors',
    emptyFile: 'File contains no valid records',
    errorImporting: 'Error importing prices',
    bulkUpload: 'Import CSV',
    downloadTemplate: 'Download Template',
    uploading: 'Importing...',
  },
  // Clients / Importers / Suppliers
  entities: {
    clients: 'Clients',
    addClient: 'New Client',
    editClient: 'Edit Client',
    noClients: 'No clients',
    importers: 'Importers',
    addImporter: 'New Importer',
    editImporter: 'Edit Importer',
    noImporters: 'No importers',
    suppliers: 'Suppliers',
    addSupplier: 'New Supplier',
    editSupplier: 'Edit Supplier',
    noSuppliers: 'No suppliers',
    contactName: 'Contact name',
    phone: 'Phone',
    address: 'Address',
    rfc: 'Tax ID',
    legalRepName: 'Legal Representative',
    docs: 'Documents',
    uploadLogo: 'Upload Logo',
    uploadSignature: 'Upload Signature',
    signature: 'Signature',
    errorLoading: 'Error loading data',
    errorSaving: 'Error saving',
    errorToggle: 'Error changing status',
    savedOk: 'Saved successfully',
    stateChanged: 'Status updated',
  },
  // Users
  users: {
    title: 'Users',
    subtitle: 'System user administration',
    addUser: 'New User',
    editUser: 'Edit User',
    role: 'Role',
    admin: 'Administrator',
    ops: 'Operations',
    clientRole: 'Client',
    active: 'Active',
    inactive: 'Inactive',
    noUsers: 'No users',
    resetPassword: 'Reset Password',
    noChange: 'No change',
    operator: 'Operator',
    loadError: 'Error loading users',
    requiredFields: 'Name, email and password are required',
    clientRequired: 'You must select a client for client-type users',
    userCreated: 'User created. Welcome email sent.',
    createError: 'Error creating user',
    statusUpdated: 'Status updated',
    statusError: 'Error changing status',
    masterRoleError: 'Error changing master admin role',
    userDeleted: 'User deleted',
    deleteError: 'Error deleting user',
    noChange: 'No change',
    operator: 'Operator',
    client: 'Client',
    administrator: 'Administrator',
    initialPassword: 'Initial password',
    associatedClient: 'Associated client',
    selectClient: 'Select client',
    welcomeEmailNote: 'A welcome email will be sent with a link to set a password.',
    confirmDelete: 'Are you sure you want to delete user',
    bulkEdit: 'Bulk Edit',
    bulkEditDescription: 'Update selected users. Only completed fields will be modified.',
    noUsers: 'No users registered',
  },
  // Catalogs
  catalogs: {
    title: 'Catalogs',
    subtitle: 'System catalog configuration',
    generalStatus: 'General Statuses',
    containerStatus: 'Container Statuses',
    eventTypes: 'Event Types',
    ports: 'Ports',
    addItem: 'New Item',
    editItem: 'Edit Item',
    code: 'Code',
    label: 'Label',
    order: 'Order',
    errorLoading: 'Error loading catalogs',
    errorSaving: 'Error saving',
    savedOk: 'Item saved',
    showInactive: 'Show inactive',
    noItems: 'No items in this catalog',
    codeHelp: 'Unique identifier (no spaces)',
    shipmentStatus: 'Shipment Status',
    incoterms: 'Incoterms',
    maintenance: 'Maintenance Tools',
    cleanMbls: 'Clean MBLs',
    cleanMblsDesc: 'Fixes whitespace and special characters in BL/MBL numbers.',
    cleanMblsConfirm: 'Run MBL cleanup?',
    cleaning: 'Cleaning...',
    runCleanup: 'Run Cleanup',
    findDuplicates: 'Find Duplicates',
    removeDuplicates: 'Remove Duplicates',
    removeDuplicatesTitle: 'Remove Duplicates',
    removeDuplicatesDesc: 'Find and remove duplicate shipments (same MBL). Keeps the most complete record.',
    removeDuplicatesConfirm: 'Remove duplicate shipments?',
    searching: 'Searching...',
    removing: 'Removing...',
    noDuplicates: 'No duplicates found',
    duplicatesFound: 'Duplicate groups found',
    records: 'records',
    migrateStatuses: 'Update Status Catalogs',
    migrateStatusesDesc: 'Update status catalogs to new format (12 shipment, 11 container).',
    migrateStatusesConfirm: 'Update status catalogs to new format?',
    migrating: 'Migrating...',
    migrateNow: 'Update Statuses Now',
  },
  // Payments
  payments: {
    title: 'Payments',
    subtitle: 'Client payment and balance control',
    paymentsBalance: 'Payment Balance',
    paymentsBalanceSubtitle: 'Manage received payments and balances by client',
    registerPayment: 'Record Payment',
    accountsReceivable: 'Accounts Receivable',
    totalPaid: 'Total Paid',
    pendingBalanceLabel: 'Pending Balance',
    activeClients: 'Active Clients',
    balancesByClient: 'Balances by Client',
    paymentHistory: 'Payment History',
    search: 'Search...',
    client: 'Client',
    shipmentsCol: 'Shipments',
    totalCost: 'Total Cost',
    paymentsCol: 'Payments',
    balanceCol: 'Balance',
    noBalanceData: 'No balance data',
    owes: 'Owes',
    inFavor: 'In favor',
    paymentMethodSummary: 'Payment Method Summary',
    allClients: 'All clients',
    selectClient: 'Select client',
    initialBalance: 'Initial Balance',
    pendingBalance: 'Pending balance from operations prior to OFIMEX',
    amountDateRequired: 'Enter the amount and date',
    initialBalanceSaved: 'Initial balance saved',
    saveError: 'Error saving initial balance',
    paymentDeleted: 'Payment deleted',
    deleteError: 'Error deleting',
    paymentUpdated: 'Payment updated',
    paymentRegistered: 'Payment registered',
    loadError: 'Error loading data',
    clientDetailError: 'Error loading client details',
  },
  // Organizations
  organizations: {
    title: 'Organizations',
    subtitle: 'Lead and organization management',
    newStatus: 'New',
    contacted: 'Contacted',
    converted: 'Converted',
    rejected: 'Rejected',
    paymentPending: 'Payment Pending',
    paymentPendingDesc: 'Monthly payment has not been received',
    paymentOverdue: 'Payment Overdue',
    paymentOverdueDesc: 'Payment is more than 30 days overdue',
    contractEnded: 'Contract Ended',
    contractEndedDesc: 'The contract has ended',
    clientRequested: 'Client Request',
    clientRequestedDesc: 'The client requested deactivation',
    other: 'Other',
    otherDesc: 'Other reason',
    leadDeleted: 'Lead deleted',
    deleteError: 'Error deleting lead',
    statusUpdated: 'Status updated',
    statusError: 'Error updating',
    loadError: 'Error loading data',
  },
  documents: {
    title: 'Documents',
    subtitle: 'Document management per shipment',
    generateInvoicePL: 'Generate Invoice + PL',
    generated: 'Document generated',
    errorGenerating: 'Error generating document',
    supplierName: 'Supplier Name',
    supplierAddress: 'Supplier Address',
    invoiceNo: 'Invoice No.',
    invoiceDate: 'Invoice Date',
    shipmentDate: 'Shipment Date',
    signatory: 'Signatory',
    importer: 'Importer',
    container: 'Container',
    vessel: 'Vessel',
    items: 'Products / Items',
    addItem: 'Add Item',
    description: 'Description',
    price: 'Price',
    qty: 'Quantity',
    unit: 'Unit',
    downloadXLSX: 'Download XLSX',
    aluminumManualOnly: 'Aluminum containers require manual Invoice/PL',
    manualInvoiceOnly: 'Manual Invoice (Aluminum)',
    generateCarta: 'Credit Letter',
    cartaDate: 'Letter Date',
    invoiceNo: 'Invoice No.',
    invoiceDate: 'Invoice Date',
    destinationPort: 'Destination Port',
    customsRegime: 'Customs Regime',
    containers: 'Containers',
    cartaGenerated: 'Letter generated successfully',
    downloadDOCX: 'Download DOCX',
    invoiceNoRequired: 'Invoice number is required',
    errorGenerating: 'Error generating document',
  },
  arnulfo: {
    pagado: 'Paid',
    pendiente: 'Pending',
    noAplica: 'N/A',
    noPermission: 'You do not have permission to access this page',
    statusUpdated: 'Status updated',
    errorUpdating: 'Error updating status',
  },
  // Register
  register: {
    title: 'Request Access',
    companyRequired: 'Company name is required',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordsMismatch: 'Passwords do not match',
    success: 'Registration successful',
    error: 'Error registering',
    step1: 'Our team will review your request',
    step2: 'You will receive confirmation by email',
    step3: 'You can access with your credentials',
    createAccount: 'Create Account',
    free: 'Free',
  },
  clientDash: {
    title: 'My Dashboard',
    subtitle: 'Summary of your shipments',
    activeShipments: 'Active Shipments',
    containers: 'Containers',
    inProcess: 'In Process',
    deliveredMonth: 'Delivered (30d)',
    activitySummary: 'Activity Summary',
    inTransit: 'In Transit',
    atPort: 'At Port/Processing',
    delivered: 'Delivered',
    recentShipments: 'My Recent Shipments',
    noShipments: 'No recent shipments found',
    statusByShipment: 'Shipments by Status',
  },
};

export default en;
